/* plaync 서비스 선택 */
$('.p-service__item').on('click',function () {
    select_service($(this));
});

window.select_service = function(active){
    if(active.hasClass('p-service__item--active'))
        $('.p-service__item').removeClass('p-service__item--active').removeClass('p-service__item--disabled');
    else{
        $('.p-service__item').removeClass('p-service__item--active').addClass('p-service__item--disabled');
        active.removeClass('p-service__item--disabled').addClass('p-service__item--active');
    }
};


/* 선수 카드 클릭 */
/*
$('.p-card__player').on('click', function () {
    $('.p-card__player').removeClass('p-card__player--selected');
    $(this).addClass('p-card__player--selected');
});
*/


/* 로그인 */
$(document).on('click', '.p-case__btn--login', function(){
    promokit.login();
});


/* 레이어 팝업 */
promokit.layer({
    el: '#layer-tickets',
    buttons: '.p-case__btn--tickets'
});
window.couponlayer = promokit.layer({
    el: '#layer-mycoupons'
});
couponlayer.on("openstart", () => {
    addrow('mycoupons');
});
promokit.layer({
    el: '#layer-reward',
    buttons: '.p-btn--reward'
});

/* 레이어 - data 갯수 카운트하여 row 추가 */
$('.p-case__btn--tickets').on('click',function () {
    addrow('mytickets');
});
function addrow(table) {
    var $tbody = $('.p-' + table).find('tbody');
    var num = $tbody.find('tr').length;
    if(num === 0) {
        append_tr($tbody, 5);
        if(table === 'mytickets') $tbody.append('<tr><td colspan="3">획득/사용 기록이 없습니다.</td></tr>');
        else $tbody.append('<tr><td colspan="3">쿠폰 획득 기록이 없습니다.</td></tr>');
        append_tr($tbody, 5);
        $($tbody).find('td').css('border-right','none');
    }
    else append_tr($tbody, 11 - num);
}
function append_tr(table, num) {
    for(var i = 0; i < num; i++){
        $(table).append('<tr><td></td><td></td><td></td></tr>');
    }
}


/* 탭 */
promokit.tab({
    el: '#tab-reward',
});


let networkLink = {
    "rc":"https://rc-id.plaync.com/identify/self/intro",
    "live":"https://go.plaync.com/account/checkrealname",
};

$.each(networkLink, function(key, value){
    if(promokitStore.network==key)
        $('.p-case__btn--realname')[0].href = value;
});


promokit.page({
    el: '#container',
    type: 'basic',
    game: 'plaync',
    cnb: true,
    caution:'#section-caution',
    topButton: true,
    footer: {
        theme: 'white'
    },
    headerButton: {
        home: false,
        event: false,
        sns: true,
        theme: 'black'
    },
    remote: {
        title: '거침없는 여정',
        home: false,
        active:false,
        template: `<ul>
                  <li><a href="#section-1">이벤트 참여하기</a></li>
                  <li><a href="#section-2">출석체크 하기</a></li>
                  <li><a href="#section-3">선수 카드 오픈</a></li>
                  <li><a href="#section-4">추가 티켓 획득</a></li>
                </ul>`
    },
});


// WEBPACK FOOTER //
// ./src/js/index.js